export const enum GameHintStage {
    NotStarted,
    ScoreInfo,
    PauseInfo,
    ExitInfo,
    Finished,
}
